
const loadMatomoScript = (siteId) => {
    var _paq = window._paq = window._paq || [];
    window._paq.push(['trackPageView']);
    window._paq.push(['setTrackerUrl', 'https://matomo.datakode.fr/matomo.php']);
    window._paq.push(['setSiteId', siteId]);
    window._paq.push(["disableCookies"]);
    window._paq.push(['enableLinkTracking']);
    const script = document.createElement('script');
    // script.async = true;
    script.src = 'https://matomo.datakode.fr/matomo.js'; // Replace with your Matomo instance URL
    document.getElementsByTagName('script')[0].parentNode?.insertBefore(script, null);
};


const setNavigationTracking = (path: string) => {
    if (window._paq) {
        window._paq.push(['setCustomUrl', window.location.href]);
        window._paq.push(['setDocumentTitle', path]);
        window._paq.push(['trackPageView']);
    }
};

export default defineNuxtPlugin((nuxtApp) => {
    // import.meta.dev est vrai uniquement quand Nuxt tourne via "npm run dev" (docker-compose.override.yml,
    // usage local) — les environnements déployés (rc/ri/demo/production) servent le build .output, jamais
    // en mode dev. Sans ce garde, le dev local envoyait un trackPageView au Matomo de prod à chaque rechargement.
    if (import.meta.client && !import.meta.dev) {
        const _mtm = (window._mtm = window._mtm || []);
        const router = nuxtApp.$router;
        const conf = nuxtApp.$config

        console.log(conf)

        _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

        loadMatomoScript(conf.public.siteId);
        // setInitTracking();

        router.afterEach((to) => {
            setNavigationTracking(to.path);
        });
    }
});
